import { Box, Skeleton } from '@mui/material';

const MapLoadingSkeleton = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#f4f4f4',
      }}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        animation="wave"
        sx={{ bgcolor: '#f4f4f4' }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '16px',
          left: '16px',
          zIndex: 1,
          display: 'flex',
          gap: '8px',
        }}
      >
        <Skeleton variant="rectangular" width={120} height={40} />
        <Skeleton variant="rectangular" width={80} height={40} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: '16px',
          right: '16px',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="circular" width={40} height={40} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '8px',
          padding: '8px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <Skeleton variant="text" width={100} height={20} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Skeleton variant="rectangular" width={20} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </Box>
      </Box>
      {[
        { top: '20%', left: '15%' },
        { top: '35%', right: '25%' },
        { top: '50%', left: '45%' },
        { bottom: '30%', left: '30%' },
        { bottom: '25%', right: '35%' },
        { top: '40%', left: '75%' },
        { bottom: '40%', right: '15%' },
      ].map((position, index) => (
        <Box
          key={index}
          sx={{
            position: 'absolute',
            ...position,
            zIndex: 1,
            color: '#9e9e9e',
            fontSize: '30px',
          }}
        >
          <i className="fa-solid fa-location-dot" />
        </Box>
      ))}
      <Box
        sx={{
          position: 'absolute',
          top: '15%',
          right: '45%',
          zIndex: 2,
          fontSize: '30px',
          color: '#9e9e9e',
        }}
      >
        <i className="fa-solid fa-location-dot" />
        <Box
          sx={{
            position: 'absolute',
            top: '45px',
            left: '15px',
            backgroundColor: '#fff',
            padding: 2,
            borderRadius: 1,
            boxShadow: 2,
            width: '150px',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: .5 }}>
            <Skeleton variant="text" width="70%" height={15} />
            <Skeleton variant="text" width="90%" height={15} />
            <Skeleton variant="text" width="60%" height={15} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MapLoadingSkeleton;
